import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

// Note: all time is converted to ENOC
const validateTime = (openTime, closeTime) => {
  const today = dayjs().format("YYYY-MM-DD");
  const parseOpenTime = dayjs(
    `${today} ${openTime}`,
    "YYYY-MM-DD h:m A",
  ).valueOf();
  const parseClosingTime = dayjs(
    `${today} ${closeTime}`,
    "YYYY-MM-DD h:m A",
  ).valueOf();

  if (
    isNaN(parseOpenTime) ||
    isNaN(parseClosingTime) ||
    !openTime ||
    !closeTime
  ) {
    return false;
  }

  return { parseOpenTime, parseClosingTime };
};

const isLessThan30mins = (openTime, closeTime) => {
  const diff = (closeTime - openTime) / 1000;
  return diff < 1800;
};

const isOpenGreaterCloseTime = (openTime, closeTime) => {
  return openTime > closeTime;
};

const isOverLap = (sched1, sched2) => {
  const min1 = Math.min(
    sched1.parseClosingTime - sched1.parseOpenTime,
    sched1.parseClosingTime - sched2.parseOpenTime,
  );
  const min2 = Math.min(
    sched2.parseClosingTime - sched2.parseOpenTime,
    sched2.parseClosingTime - sched1.parseOpenTime,
  );

  return Math.min(min1, min2) >= 0;
};

const isValidDays = (days) => Array.isArray(days) && days.length > 0;

const checkSchedule = (sched, schedIndex = 0, schedules = []) => {
  const error = {
    status: "",
    message: "",
    invalidTime: false,
    invalidDays: false,
  };
  const validTime = validateTime(sched?.openTime, sched?.closeTime);
  const validDays = isValidDays(sched?.days);

  if (!sched?.openTime || !sched?.closeTime) {
    error.invalidTime = true;
  }

  if (!validDays) {
    error.invalidDays = true;
  }

  if (!validTime || !validDays) {
    error.status = "error";
    error.message =
      "Unable to save. Please set the day/time for this schedule.";
    return error;
  }

  if (isLessThan30mins(validTime.parseOpenTime, validTime.parseClosingTime)) {
    error.status = "error";
    error.message = "Please set time greater than 30 minutes.";
    error.invalidTime = true;
    return error;
  }

  const conflictSchedule = new Set();
  let hasConflictSched = false;

  for (let i = 0; i < schedules.length; i++) {
    if (schedIndex === i) {
      continue;
    }

    sched.days.forEach((day) => {
      const sched2Id = i + 1;

      const hasConflict = schedules[i]?.days.includes(day);

      if (hasConflict) {
        const sched2 = validateTime(
          schedules[i]?.openTime,
          schedules[i]?.closeTime,
        );
        if (sched2 && isOverLap(sched2, validTime)) {
          conflictSchedule.add(sched2Id);
          hasConflictSched = true;
        }
      }
    });
  }

  if (hasConflictSched) {
    let conflictingSchedIDs = Array.from(conflictSchedule).join(", ");
    if (conflictingSchedIDs.includes(",")) {
      conflictingSchedIDs = conflictingSchedIDs.replace(/,([^,]*)$/, " &$1");
    }

    error.status = "error";
    error.message = `Oops! Scheduling conflict with Schedule ${conflictingSchedIDs} for the chosen day and time.`;
    error.invalidTime = true;
    error.invalidDays = true;
    return error;
  }

  return error;
};

export {
  validateTime,
  isLessThan30mins,
  isOpenGreaterCloseTime,
  isOverLap,
  isValidDays,
  checkSchedule,
};
